import { ReactNode } from 'react';
import Box from '@mui/material/Box';
import useMediaQuery from '@mui/material/useMediaQuery';
import { UI_ZOOM, UI_ZOOM_MEDIA, useUiZoom } from '../../../context/UiZoomContext';
import { UI_TOKENS } from '../../../constants/designTokens';

interface iTableCardProps {
  /** Above the toolbar, e.g. the title and a primary action. */
  header?: ReactNode;
  toolbar: ReactNode;
  /** The `DataTable` and its footer. */
  children: ReactNode;
}

/**
 * The design's card around a toolbar and table — it grows with its rows and the page scrolls. It renders at the
 * Caterers pages' interface size (UI_ZOOM) wherever the page itself isn't zoomed, so every list reads alike.
 */
const TableCard = ({ header, toolbar, children }: iTableCardProps) => {
  const pageZoom = useUiZoom();
  const wide = useMediaQuery(UI_ZOOM_MEDIA);
  return (
    <Box
      data-table-card
      sx={{
        zoom: wide ? UI_ZOOM / pageZoom : 1,
        bgcolor: UI_TOKENS.surfaceCard,
        border: `1px solid ${UI_TOKENS.borderSubtle}`,
        borderRadius: UI_TOKENS.radiusLg,
        boxShadow: UI_TOKENS.shadowSm,
        display: 'flex',
        flexDirection: 'column',
        minWidth: 0,
        fontFamily: UI_TOKENS.fontSans,
      }}
    >
      {header}
      {toolbar}
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          overflow: 'hidden',
          borderRadius: `0 0 ${UI_TOKENS.radiusLg} ${UI_TOKENS.radiusLg}`,
        }}
      >
        {children}
      </Box>
    </Box>
  );
};

export default TableCard;
